import React, { useState, createContext, useContext } from 'react';
export type Branch = {
  id: string;
  name: string;
  address: string;
  phone: string;
  hours: string;
  location: [number, number]; // [latitude, longitude]
  image: string;
};
export type Service = {
  id: string;
  name: string;
  description: string;
  duration: number;
  price: number;
  image: string;
};
export type Stylist = {
  id: string;
  name: string;
  specialization: string;
  experience: string;
  image: string;
};
export type BookingState = {
  step: number;
  branch: Branch | null;
  service: Service | null;
  stylist: Stylist | null;
  date: Date | null;
  time: string | null;
  customerName: string;
  customerEmail: string;
  customerPhone: string;
};
type BookingContextType = {
  booking: BookingState;
  setBooking: React.Dispatch<React.SetStateAction<BookingState>>;
  nextStep: () => void;
  prevStep: () => void;
  setStep: (step: number) => void;
  resetBooking: () => void;
};
const initialState: BookingState = {
  step: 1,
  branch: null,
  service: null,
  stylist: null,
  date: null,
  time: null,
  customerName: '',
  customerEmail: '',
  customerPhone: ''
};
const BookingContext = createContext<BookingContextType | undefined>(undefined);
export const BookingProvider: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  const [booking, setBooking] = useState<BookingState>(initialState);
  const nextStep = () => {
    setBooking(prev => ({
      ...prev,
      step: prev.step + 1
    }));
  };
  const prevStep = () => {
    setBooking(prev => ({
      ...prev,
      step: Math.max(1, prev.step - 1)
    }));
  };
  const setStep = (step: number) => {
    setBooking(prev => ({
      ...prev,
      step
    }));
  };
  const resetBooking = () => {
    setBooking(initialState);
  };
  return <BookingContext.Provider value={{
    booking,
    setBooking,
    nextStep,
    prevStep,
    setStep,
    resetBooking
  }} data-id="element-187">
      {children}
    </BookingContext.Provider>;
};
export const useBooking = () => {
  const context = useContext(BookingContext);
  if (context === undefined) {
    throw new Error('useBooking must be used within a BookingProvider');
  }
  return context;
};